import "@babel/polyfill";
import stars from "./__modules/particle";
import map from "./__modules/map";
import header from "./__modules/header";
import faq from "./__modules/faq";
import role from "./__modules/role";
import loader from "./__modules/loader";
import locomotiveInit from "./__modules/locomotive";
import news from "./__modules/news";
import inspiration from "./__modules/inspiration";
import research from "./__modules/reasearch";
import project from "./__modules/project";
import lottieInit from "./__modules/lottieInit";
//import bannerInit from "./__modules/bannerInit";
import about from "./__modules/about";
import scrollOffset from "./__modules/scrollOffset";

document.addEventListener('DOMContentLoaded', () => {
	loader();
	scrollOffset();

	if (document.querySelector('#map')) {
		map();
	}
});

window.addEventListener('load', () => {
	const scroll = locomotiveInit();

	if (document.querySelector('.header')) {
		header();
	}

	if (document.querySelector('#stars')) {
		stars();
	}

	if (document.querySelector('.faq')) {
		faq(scroll);
	}

	if (document.querySelector('.role')) {
		role();
	}
	
	if (document.querySelector('.news')) {
		news(scroll);
	}
	
	if (document.querySelector('.inspiration__list')) {
		inspiration(scroll);
	}
	
	if (document.querySelector('#hero__btn')) {
		research(scroll);
	}
	
	if (document.querySelector('.project__more--about')) {
		project();
	}

	if(document.querySelector('.project__card') || document.querySelector('.hero__globe') || document.querySelector('.inspiration__img') || document.querySelector('.opportunities__img')) {
		lottieInit();
	}

	// if(document.querySelector('.banner')) {
	// 	bannerInit();
	// }
	
	if(document.querySelector('.about .swiper')) {
		about();
	}

});

window.addEventListener('resize', () => {
	// Add any additional logic for the resize event here
});

window.addEventListener('scroll', () => {
	// Add any additional logic for the scroll event here
});
